import { ServiceRequestConfig } from '~/services/createService';
import { k2 } from '~/services/serviceInstances';

import {
  CreateTicketApiArg,
  CreateTicketApiResponse,
} from '../../types/k2/tickets';

type Request = {
  name: string;
  workflowId: string;
};

type ServerRequest = CreateTicketApiArg;
type ServerResponse = CreateTicketApiResponse;

export const createTicketK2 = async (
  request: Request,
  options: ServiceRequestConfig = {},
) => {
  const params = mapParams(request);

  const serverResponse: ServerResponse = await k2.post(
    '/tickets',
    params.createTicketRequest,
    { showErrorToast: true, ...options },
  );

  return mapResponse(serverResponse);
};

const mapParams = (request: Request): ServerRequest => {
  return {
    createTicketRequest: {
      data: {
        type: 'tickets',
        attributes: {
          name: request.name,
        },
        relationships: {
          workflow: {
            data: {
              type: 'workflows',
              id: request.workflowId,
            },
          },
        },
      },
    },
  };
};

const mapResponse = (serverResponse: ServerResponse) => {
  if (serverResponse === null) {
    return null;
  }

  return { id: serverResponse.data.id, ...serverResponse.data.attributes };
};
